/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createFormat } from '../../factoriesAny.js';
export var formatDependencies = {
  typedDependencies: typedDependencies,
  createFormat: createFormat
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFormat.generated.js
// module id = 501
// module chunks = 0